import type { DocVariableSnapshot } from "../versions/snapshotTypes.js";

export type DocVariableValues = Record<string, string>;

export function parseVariablesSnapshot(raw: unknown): DocVariableSnapshot[] {
  if (!Array.isArray(raw)) return [];
  const out: DocVariableSnapshot[] = [];
  for (const row of raw) {
    if (!row || typeof row !== "object" || Array.isArray(row)) continue;
    const o = row as Record<string, unknown>;
    const key = typeof o.key === "string" ? o.key.trim() : "";
    const label = typeof o.label === "string" ? o.label.trim() : "";
    if (!key || !label) continue;
    out.push({
      key,
      label,
      default_value: typeof o.default_value === "string" ? o.default_value : "",
      required: o.required === true,
    });
  }
  return out;
}

export function buildInitialVariableValues(
  variables: readonly DocVariableSnapshot[],
): DocVariableValues {
  const values: DocVariableValues = {};
  for (const v of variables) {
    values[v.key] = v.default_value ?? "";
  }
  return values;
}

export function getUnresolvedRequiredVariables(
  variables: readonly DocVariableSnapshot[],
  values: DocVariableValues,
): DocVariableSnapshot[] {
  return variables.filter((v) => {
    if (!v.required) return false;
    const current = values[v.key] ?? "";
    return !current.trim();
  });
}

export function hasUnresolvedRequiredVariables(
  variables: readonly DocVariableSnapshot[],
  values: DocVariableValues,
): boolean {
  return getUnresolvedRequiredVariables(variables, values).length > 0;
}
